import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { arrayOf, func, string, shape, bool } from 'prop-types';
import Text from '@magalu/stereo-ui/atoms/Text';
import Link from '@magalu/stereo-ui/atoms/Link';
import { capitalize } from '../../utils';
import { HeaderLinksContainer } from './header-links.styles';

const HeaderLinks = _ref => {
  let {
    data,
    onClick,
    isMobile,
    isRendered
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "onClick", "isMobile", "isRendered"]);

  const {
    links,
    title
  } = data;
  if ((links == null ? void 0 : links.length) >= 1 && title) return /*#__PURE__*/React.createElement(HeaderLinksContainer, _extends({
    display: isRendered ? 'flex' : 'none',
    "data-testid": "header-links-list",
    isMobile: isMobile
  }, props, {
    color: "text.lightest"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "text.lightest"
  }, `${title}: `), links == null ? void 0 : links.map((link, index) => {
    const pipe = index !== 0 && /*#__PURE__*/React.createElement("span", null, " | ");
    return /*#__PURE__*/React.createElement(React.Fragment, null, pipe, /*#__PURE__*/React.createElement(Link, {
      "data-testid": "header-link",
      key: link.value,
      href: link.href,
      onClick: e => onClick(e, link),
      hover: false,
      color: "text.lightest"
    }, capitalize(link.value)));
  }));
  return null;
};

process.env.NODE_ENV !== "production" ? HeaderLinks.propTypes = {
  data: shape({
    links: arrayOf(shape({
      href: string,
      value: string
    })),
    title: string
  }),
  onClick: func,
  isRendered: bool,
  isMobile: bool
} : void 0;
HeaderLinks.defaultProps = {
  data: {
    links: [],
    title: ''
  },
  onClick: () => {},
  isMobile: false,
  isRendered: true
};
export default HeaderLinks;